export const twoNumsSeconds = (seconds: number) => {
  return seconds < 10 ? '0' + seconds : String(seconds);
};

// dd.mm.yyyy, hh:mm
export const formatDate = (date: Date, withTime = true, fullYear = true) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const fullYearDate = date.getFullYear();
  const year = fullYear ? fullYearDate : String(fullYearDate).slice(2);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  if (withTime) {
    return `${day}.${month}.${year}, ${hours}:${minutes}`;
  } else {
    return `${day}.${month}.${year}`;
  }
};
